import React from 'react'
import dayjs from 'dayjs'
import { formatDateRange } from '../../math/format'
import { DateWindow, comparisonWindowFor } from '../../math/windows'
import '../../components/org-dashboard.scss'

type Props = {
    range: DateWindow
    /** Last Month is compared with the calendar month before it. */
    rangeKey?: string
    /** Set when the metric definitions on screen came from an earlier read rather than the current one. */
    definitionsCachedAt?: Date
}

export const ComparisonSummary: React.FC<Props> = ({ range, rangeKey, definitionsCachedAt }) => {
    const comparison = comparisonWindowFor(range, rangeKey)
    return (
        <span className="org-dashboard-comparison-summary">
            <span>{`Compared with ${formatDateRange(comparison)}`}</span>
            {definitionsCachedAt && (
                <span>{` · Definitions from cache, ${dayjs(definitionsCachedAt).format('h:mm A')}`}</span>
            )}
        </span>
    )
}
